var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"m-l-15",on:{"click":_vm.show}},[_c('i',{staticClass:"icon-refresh"}),_vm._v(" Mover entre cajas ")])
}
var staticRenderFns = []

export { render, staticRenderFns }